export const defaultFilters = {
  query: "",
  role: "All roles",
  location: "All locations",
  workMode: "Any work mode",
  salary: "Any salary",
  experienceLevel: "Any level",
  source: "Any source",
  licensedSponsor: "Any",
};

export const filterOptions = {
  role: ["All roles", "Engineering", "Data", "Customer Success", "Marketing", "Design", "Finance"],
  location: ["All locations", "London", "Manchester", "Birmingham", "Leeds", "Bristol", "Edinburgh"],
  workMode: ["Any work mode", "Remote", "Hybrid", "On-site"],
  salary: ["Any salary", "30k+", "40k+", "50k+", "60k+"],
  experienceLevel: ["Any level", "Entry level", "Mid level", "Senior level"],
  source: ["Any source", "Jobs by Reed", "Jobs by Adzuna", "LinkedIn", "Indeed", "Company Website", "Demo fallback"],
  licensedSponsor: ["Any", "Licensed Sponsor"],
};

function salaryFloor(label) {
  if (label === "30k+") return 30000;
  if (label === "40k+") return 40000;
  if (label === "50k+") return 50000;
  if (label === "60k+") return 60000;
  return 0;
}

export function filterJobs(jobs, filters) {
  const query = filters.query.trim().toLowerCase();
  const minimumSalary = salaryFloor(filters.salary);

  return jobs.filter((job) => {
    const searchable = [
      job.title,
      job.company,
      job.location,
      job.role,
      job.source || job.source_label,
      job.workMode,
      ...(job.skillsMatched || job.matched_skills || []),
      ...(job.missingKeywords || job.missing_keywords || []),
    ]
      .join(" ")
      .toLowerCase();

    if (query && !searchable.includes(query)) return false;
    if (filters.role !== "All roles" && job.role !== filters.role) return false;
    if (
      filters.location !== "All locations" &&
      !(job.location || "").toLowerCase().includes(filters.location.toLowerCase())
    ) {
      return false;
    }
    if (filters.workMode !== "Any work mode" && job.workMode !== filters.workMode) return false;
    if (filters.experienceLevel !== "Any level" && job.experienceLevel !== filters.experienceLevel) {
      return false;
    }
    if (filters.source !== "Any source" && (job.source || job.source_label) !== filters.source) return false;
    if (minimumSalary && (job.salaryMax || 0) < minimumSalary) return false;
    
    if (filters.licensedSponsor !== "Any") {
      if (job.licensedSponsorStatus?.is_licensed_sponsor !== true) return false;
    }

    return true;
  });
}
